//#region String helper functions

/**
 * Generic function to convert a string to lowercase.
 * For use in pipe functions.
 */
export function lowerCase<T extends string>(str: T): Lowercase<T> {
  return str.toLowerCase() as Lowercase<T>;
}

//#endregion

//#region Array helper functions

/**
 * Flatten 2d array
 * @param 2d array
 * @returns flattened array
 * @example
 * const arr = [[1, 2], [3, 4]];
 * const flatArr = flatten(arr);
 * console.log(flatArr); // [1, 2, 3, 4]
 */
export const flatten = <T>(arr: T[][]): T[] => arr.reduce((acc, val) => acc.concat(val), []);

/**
 * This is just for better readability. It returns true if the parameter is -1, false otherwise.
 * To be used with index returned from Array.findIndex().
 * @param idx
 * @returns boolean
 * @example
 * const arr = [1, 2, 3];
 * const idx = arr.findIndex((n) => n === 4);
 * if (notInArray(idx)) {
 *  // do something
 * }
 */
export const notInArray = (idx: number): boolean => idx === -1;

//#endregion
